import React from 'react';
import { useRecoilValue } from 'recoil';

import { CarrierLogo } from '@/components/modules/carrier/logo';
import { Text } from '@/components/text';
import { getCarrierName } from '@/lib/models/carrier/utils/get-carrier-name';
import { getCarriersByIdsState } from '@/state/carriers';
import { SegmentModeType } from '@/types/api-types';
import { tv } from '@/utils/styles';

export interface CarrierLogoListNamesProps {
  carrierIds: string[];
  mode: SegmentModeType;
}

const CarrierLogoListNames = ({ carrierIds, mode }: CarrierLogoListNamesProps) => {
  const carriers = useRecoilValue(getCarriersByIdsState(carrierIds));

  const { carrierItem, base } = styles();
  return (
    <ul className={base()}>
      {carriers.map((carrier, i) => {
        const carrierName = getCarrierName(carrier);

        return (
          <li className={carrierItem()} key={`${i}${carrier.identifiers[0]?.value}`}>
            <CarrierLogo carrier={carrier} mode={mode} />
            <Text as="span" variant="sm">
              {carrierName}
            </Text>
          </li>
        );
      })}
    </ul>
  );
};

const styles = tv({
  slots: {
    base: 'flex flex-wrap gap-x-3 gap-y-1',
    carrierItem: 'flex items-center gap-1 whitespace-nowrap',
  },
});

export { CarrierLogoListNames };
